import React from "react";
import {
  useLocation,
  useOutletContext,
  useSearchParams,
} from "react-router-dom";
import "../../styles/institution/institutionBatchDetails.scss";
import { useEffect, useState } from "react";
import InstitutionStudent from "./institutionStudent";
import InstitutionTeacher from "./institutionTeacher";

const InstitutionBatchDetails = () => {
  const [searchParams] = useSearchParams();
  const batchId = searchParams.get("batch_id");
  const institution_id = searchParams.get("institution");
  const location = useLocation();
  const tabs = [
    { key: "teacher", label: "Teachers" },
    { key: "students", label: "Students" },
  ];

  const [activeTab, setActiveTab] = useState(tabs[0].key);
  const { setHeaderName } = useOutletContext() || {};
  const renderTabContent = () => {
    switch (activeTab) {
      case "students":
        return <InstitutionStudent batch={true} batchId={batchId} />;
      case "teacher":
        return <InstitutionTeacher batch={true} batchId={batchId} />;

      default:
        return null;
    }
  };

  const title = location?.state?.batchName;
  useEffect(() => {
    setHeaderName(
      title?.charAt(0).toUpperCase() + title?.slice(1) || "Batch Information"
    );
  }, []);

  return (
    <div>
      <div className="institution-batch-details-info">
        <div className="institution-batch-details-tab-container">
          <div
            className="institution-batch-details-segmented-tabs"
            role="tablist"
            aria-label="Batch tabs"
          >
            {tabs.map((tab) => (
              <button
                key={tab.key}
                type="button"
                role="tab"
                aria-selected={activeTab === tab.key}
                className={`institution-batch-details-segmented-tab ${
                  activeTab === tab.key ? "active" : ""
                }`}
                onClick={() => setActiveTab(tab.key)}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>

        <div
          className="institution-batch-details-tab-panel"
          role="tabpanel"
          aria-live="polite"
        >
          {renderTabContent()}
        </div>
      </div>
    </div>
  );
};

export default InstitutionBatchDetails;
